import { pages, site } from '../mdx/seo.mdx';
import { collectPages } from './resolve.mjs';

const services = require.context('../mdx/services', false, /\.mdx$/);
const restaurants = require.context('../mdx/services/Restaurant', true, /\.mdx$/);
const blogs = require.context('../mdx/blogs', false, /\.mdx$/);
const projects = require.context('../mdx/projects', false, /\.mdx$/);
const entries = (context, prefix) => context.keys().map((key) => {
  const metadata = context(key).metadata;
  return { ...metadata, path: `${prefix}${metadata.slug}`, type: prefix === '/blog/' ? 'article' : 'website' };
});

// The nested restaurant source is authoritative for the main restaurant page.
export const seoPages = collectPages(pages, [
  ...entries(services, '/').filter((entry) => entry.path !== '/restaurant'),
  ...entries(restaurants, '/'), ...entries(blogs, '/blog/'), ...entries(projects, '/projects/'),
]);
export { site };
